import { StorySourceEnum, type StoryVideoModel } from '@/apiTypes/VideoTypes';
import type { UnifiedVideoItem } from '@/components/Video/unifiedVideoTypes';
import { storyThumbUrl } from '@/pages/Explore/Stories/storyThumb';

// `quote`, `interviewLocation` and `interviewId` have no catalog column, so they are filled here
// rather than made optional on the model every other Roadtrip Nation caller shares. Cloudflare
// stories map to `other`, whose player cannot show them, which is a card problem not a mapper one.
export const storyToUnifiedVideoItem = (story: StoryVideoModel): UnifiedVideoItem => {
    const thumbUrl = storyThumbUrl(story) ?? '';

    if (story.source === StorySourceEnum.ROADTRIP_NATION) {
        return {
            sourceType: 'roadtripNation',
            id: story.id,
            storyId: story.id,
            title: story.title,
            creator: story.sourceLabel,
            thumbUrl,
            data: {
                // The player is set up from `mp4Url` so the asset id only has to be stable.
                jwAssetId: story.id,
                fullName: story.personName ?? '',
                quote: '',
                company: story.company ?? '',
                interviewLocation: '',
                jobTitle: story.jobTitle ?? '',
                mp4Url: story.videoUrl,
                thumbUrl,
                captionsUrl: story.captionsUrl,
                interviewId: 0,
                partNumber: story.partNumber,
                partTotal: story.partTotal,
            },
        };
    }

    return {
        sourceType: 'other',
        id: story.id,
        storyId: story.id,
        title: story.title,
        creator: story.sourceLabel,
        thumbUrl,
        data: {
            id: story.id,
            videoUrl: story.videoUrl,
            videoTitle: story.title,
        },
    };
};
